import type { ReactNode } from 'react';

/** Barra de filtros acima da tabela (`.card.filters`): SearchInput + Selects. */
export function TableFilters({ children, label = 'Filtros' }: { children: ReactNode; label?: string }) {
  return <section className="card filters" aria-label={label}>{children}</section>;
}
